import { Component } from '@angular/core';

@Component({
  selector: 'sellions-layout-renderer-spinner',
  templateUrl: './spinner.component.html',
  })
export class SpinnerComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/spinner/spinner.component.ts